import { pushNotification } from '@/features/notifications/push'
import { resolveMessage } from '../resolve-message'
import type { MessageKey, MessageParams } from '../domain/message'
import type { NotifyPort } from '../domain/notify'

const notifyAdapter: NotifyPort = {
	success: (key: MessageKey, params?: MessageParams) =>
		pushNotification({ level: 'success', variant: 'toast', message: resolveMessage(key, params) }),
	error: (key: MessageKey, params?: MessageParams) =>
		pushNotification({ level: 'error', variant: 'toast', message: resolveMessage(key, params) }),
}

export { notifyAdapter }
